// extracted by mini-css-extract-plugin
export var actionIcon = "_uq-0";